// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CancellationPolicyManagement-commonHeaderAdmin-RIP8F {
	position: fixed !important;
}

.CancellationPolicyManagement-adminLayout-Ov0Sf {
	padding-top: 64px !important;
}

.CancellationPolicyManagement-box-uJBFP h2 {
	font-size: 21px;
	font-weight: 600;
}

.CancellationPolicyManagement-exportLink-PByaO {
	margin-bottom: -29px;
}

.CancellationPolicyManagement-blockCenter-MxLKL {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.CancellationPolicyManagement-panelHeader-VARS7 {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.CancellationPolicyManagement-currencyselect-TkNSy {
	width: 100%;
	margin-right: 0px;
}

.CancellationPolicyManagement-panelHeader-VARS7 {
	overflow: hidden;
	position: relative;
}

.CancellationPolicyManagement-mar0-zycNC {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.CancellationPolicyManagement-blockCenter-MxLKL {
		padding: 0px;
	}

	.CancellationPolicyManagement-panelHeader-VARS7 {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.CancellationPolicyManagement-sideAdminPageWrapper-eqWuw {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.CancellationPolicyManagement-panelHeader-VARS7 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.CancellationPolicyManagement-table-OvHJP {
	display: table;
}

.CancellationPolicyManagement-tableRow-TuBhm {
	display: table-row;
}

.CancellationPolicyManagement-tableCell-erUPb {
	display: table-cell;
	float: none;
}

.CancellationPolicyManagement-formGroup-KiSJ0 {
	margin-bottom: 6px;
}

.CancellationPolicyManagement-select-faNxf {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.CancellationPolicyManagement-noMargin-B4skC {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.CancellationPolicyManagement-exportLink-PByaO {
	padding-top: 10px;
	padding-right: 10px;
}

.CancellationPolicyManagement-labelTextNew-NP8dw {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.CancellationPolicyManagement-displayInline-aL6cH {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.CancellationPolicyManagement-btnUPdate-goS_I {
	display: inline-block;
}

.CancellationPolicyManagement-btnModalDelete-sHqsA {
	display: inline-block;
	margin-left: 15px;
}

.CancellationPolicyManagement-radioBtn-s3lJ1 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.CancellationPolicyManagement-backgroundImg-ahcLr {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.CancellationPolicyManagement-btnUPdate-goS_I {
		display: block;
		margin-bottom: 12px;
	}

	.CancellationPolicyManagement-btnModalDelete-sHqsA {
		display: block;
		margin-left: 0px;
	}

	.CancellationPolicyManagement-btnWidth-_bO0f {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.CancellationPolicyManagement-bannerImageBg-sct81 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.CancellationPolicyManagement-bannerDelete-OPtaz {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.CancellationPolicyManagement-modalRoot-JEvWL {
	padding: 32px;
}

.CancellationPolicyManagement-modalBorderBottom-L21Lr {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.CancellationPolicyManagement-logInModalBody-xGaTT {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.CancellationPolicyManagement-exportSection-Rpmh9 {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.CancellationPolicyManagement-exportSectionGridSub-oJ1u7 {
	grid-template-columns: 50% 49% !important;
}

.CancellationPolicyManagement-exportText-pub_4 {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.CancellationPolicyManagement-exportLinkImg-MujIM {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.CancellationPolicyManagement-vtrMiddle-sDAdm {
	vertical-align: middle;
}

.CancellationPolicyManagement-exportImg-i81E7 {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.CancellationPolicyManagement-profileViewlabel-l_6Rz {
	display: inline-block;
	width: 38%
}

.CancellationPolicyManagement-profileViewMainContent-FVlyY {
	display: inline-block;
	width: 62%;
}

.CancellationPolicyManagement-profileViewMain-I234Z {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.CancellationPolicyManagement-profileViewInner-zWNGL {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.CancellationPolicyManagement-profileImageSection-_buVN {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.CancellationPolicyManagement-lastviewInner-cs0Cx {
	padding: 10px;
}

.CancellationPolicyManagement-whyHostHoriLine-qUVWG {
	margin: 30px 0;
}

.CancellationPolicyManagement-tableGrid-HswnC {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.CancellationPolicyManagement-headingContent-rk3Fs {
	font-size: 18px;
	font-weight: 500;
}

.CancellationPolicyManagement-refundTextColor-mILpG {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.CancellationPolicyManagement-dividerLine-ccbQp {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.CancellationPolicyManagement-smallContent-jDYVv {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.CancellationPolicyManagement-sideAdminPageWrapper-eqWuw {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.CancellationPolicyManagement-sideAdminPageWrapper-eqWuw {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.CancellationPolicyManagement-exportSection-Rpmh9 {
		grid-template-columns: 100%;
	}

	.CancellationPolicyManagement-exportSectionGridSub-oJ1u7 {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.CancellationPolicyManagement-profileViewlabel-l_6Rz {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.CancellationPolicyManagement-profileViewMainContent-FVlyY {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.CancellationPolicyManagement-ChangeToUpperCase-eCf3r {
	text-transform: uppercase
}

.CancellationPolicyManagement-noBorder-rU5yd {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.CancellationPolicyManagement-siteAdminHeading-P5WMZ {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.CancellationPolicyManagement-siteAdminSubHeading-dlML2 {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.CancellationPolicyManagement-adminFormDivider-OWaqb {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.CancellationPolicyManagement-errorMessage-qoqFl {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.CancellationPolicyManagement-panelHeader-VARS7 {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.CancellationPolicyManagement-formGroup-KiSJ0 {
  margin-bottom: 6px;
}

.CancellationPolicyManagement-select-faNxf {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.CancellationPolicyManagement-labelText-agptO {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.CancellationPolicyManagement-space1-MHzkV {
	margin-bottom: 6px !important;
}

.CancellationPolicyManagement-space2-FFBzq {
	margin-bottom: 12px !important;
}

.CancellationPolicyManagement-space3-C0lUq {
	margin-bottom: 18px !important;
}

.CancellationPolicyManagement-space4-BJuay {
	margin-bottom: 24px !important;
}

.CancellationPolicyManagement-space5-uXpd0 {
	margin-bottom: 30px !important;
}

.CancellationPolicyManagement-space6-cqdmg {
	margin-bottom: 36px !important;
}

.CancellationPolicyManagement-space7-kl7ui {
	margin-bottom: 42px !important;
}

.CancellationPolicyManagement-spaceTop8-ZhGQu {
	margin-bottom: 48px !important;
}

.CancellationPolicyManagement-spaceTop1-XdLoO {
	margin-top: 6px !important;
}

.CancellationPolicyManagement-spaceTop2-kmjTA {
	margin-top: 12px !important;
}

.CancellationPolicyManagement-spaceTop3-doHmD {
	margin-top: 18px !important;
}

.CancellationPolicyManagement-spaceTop4-f4cKX {
	margin-top: 24px !important;
}

.CancellationPolicyManagement-spaceTop5-fMFUn {
	margin-top: 30px !important;
}

.CancellationPolicyManagement-spaceTop6-IkdYi {
	margin-top: 36px !important;
}

.CancellationPolicyManagement-spaceTop7-mSq5J {
	margin-top: 42px !important;
}

.CancellationPolicyManagement-spaceTop8-ZhGQu {
	margin-top: 48px !important;
}

.CancellationPolicyManagement-noMargin-B4skC {
	margin: 0px !important;
}

.CancellationPolicyManagement-padding1-FQDFC {
	padding-bottom: 6px !important;
}

.CancellationPolicyManagement-padding2-aVaK2 {
	padding-bottom: 12px !important;
}

.CancellationPolicyManagement-padding3-OqvXV {
	padding-bottom: 18px !important;
}

.CancellationPolicyManagement-padding4-kFcAh {
	padding-bottom: 24px !important;
}

.CancellationPolicyManagement-padding5-wGko2 {
	padding-bottom: 30px !important;
}

.CancellationPolicyManagement-padding6-KTFAs {
	padding-bottom: 36px !important;
}

.CancellationPolicyManagement-padding7-eMibu {
	padding-bottom: 42px !important;
}

.CancellationPolicyManagement-paddingTop1-dU8rN {
	padding-top: 6px !important;
}

.CancellationPolicyManagement-paddingTop2-HauXV {
	padding-top: 12px !important;
}

.CancellationPolicyManagement-paddingTop3-FcFnV {
	padding-top: 18px !important;
}

.CancellationPolicyManagement-paddingTop4-Rq_EX {
	padding-top: 24px !important;
}

.CancellationPolicyManagement-paddingTop5-cZ1w9 {
	padding-top: 30px !important;
}

.CancellationPolicyManagement-paddingTop6-eMWsk {
	padding-top: 36px !important;
}

.CancellationPolicyManagement-paddingTop7-kzEOn {
	padding-top: 42px !important;
}

.CancellationPolicyManagement-noPadding-flvo9 {
	padding: 0px !important;
}

.CancellationPolicyManagement-textBold-uLMo7 {
	font-weight: 500 !important;
}

.CancellationPolicyManagement-textBolder-NkpVv {
	font-weight: 700 !important;
}

.CancellationPolicyManagement-textNormal-VyKyT {
	font-weight: normal !important;
}

.CancellationPolicyManagement-spaceBottom20-Bagj1 {
	margin-bottom: 20px;
}

.CancellationPolicyManagement-spaceBottom10-PSq5E {
	margin-bottom: 10px;
}

.CancellationPolicyManagement-marginNone-tqtXZ {
	margin: 0;
}

.CancellationPolicyManagement-spaceBottom15-z8j8b {
	margin-bottom: 15px;
}

.CancellationPolicyManagement-marginTopNone-W6GoS {
	margin-top: 0;
}

.CancellationPolicyManagement-spaceTop11-SMGgg {
	margin-top: 11px;
}

.CancellationPolicyManagement-spaceTop21-mqgMb {
	margin-top: 21px;
}

.CancellationPolicyManagement-spaceTop20-iqXE4 {
	margin-top: 20px;
}

.CancellationPolicyManagement-spaceTop10-N4m3V {
	margin-top: 10px;
}

/*New Design Text Colors */

.CancellationPolicyManagement-textDarkBlue-qijaL {
	color: rgb(20, 39, 94) !important;
}

.CancellationPolicyManagement-textLightBlue-h8lif {
	color: rgb(57, 87, 106) !important;
}

.CancellationPolicyManagement-textLightSandleGreen-h04Gk {
	color: rgb(76, 86, 41) !important;
}

.CancellationPolicyManagement-textLightBrown-v9Jwf {
	color: rgb(115, 79, 33) !important;
}

.CancellationPolicyManagement-textMediumMaroon-BWH1Q {
	color: rgb(87, 37, 51) !important;
}

.CancellationPolicyManagement-textBrown-udFxa {
	color: rgb(160, 47, 24) !important;
}

.CancellationPolicyManagement-textMaroon-NpnmH {
	color: rgb(155, 49, 67) !important;
}

.CancellationPolicyManagement-textDarkBrown-SGnxw {
	color: rgb(83, 18, 16) !important;
}

.CancellationPolicyManagement-textMediumBrown-ObStR {
	color: rgb(142, 28, 10) !important;
}

.CancellationPolicyManagement-textSkyBlue-UKAS6 {
	color: rgb(37, 117, 141) !important;
}

.CancellationPolicyManagement-textGray-v9KxN {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `CancellationPolicyManagement-commonHeaderAdmin-RIP8F`,
	"adminLayout": `CancellationPolicyManagement-adminLayout-Ov0Sf`,
	"box": `CancellationPolicyManagement-box-uJBFP`,
	"exportLink": `CancellationPolicyManagement-exportLink-PByaO`,
	"blockCenter": `CancellationPolicyManagement-blockCenter-MxLKL`,
	"panelHeader": `CancellationPolicyManagement-panelHeader-VARS7`,
	"currencyselect": `CancellationPolicyManagement-currencyselect-TkNSy`,
	"mar0": `CancellationPolicyManagement-mar0-zycNC`,
	"sideAdminPageWrapper": `CancellationPolicyManagement-sideAdminPageWrapper-eqWuw`,
	"table": `CancellationPolicyManagement-table-OvHJP`,
	"tableRow": `CancellationPolicyManagement-tableRow-TuBhm`,
	"tableCell": `CancellationPolicyManagement-tableCell-erUPb`,
	"formGroup": `CancellationPolicyManagement-formGroup-KiSJ0`,
	"select": `CancellationPolicyManagement-select-faNxf`,
	"noMargin": `CancellationPolicyManagement-noMargin-B4skC`,
	"labelTextNew": `CancellationPolicyManagement-labelTextNew-NP8dw`,
	"displayInline": `CancellationPolicyManagement-displayInline-aL6cH`,
	"btnUPdate": `CancellationPolicyManagement-btnUPdate-goS_I`,
	"btnModalDelete": `CancellationPolicyManagement-btnModalDelete-sHqsA`,
	"radioBtn": `CancellationPolicyManagement-radioBtn-s3lJ1`,
	"backgroundImg": `CancellationPolicyManagement-backgroundImg-ahcLr`,
	"btnWidth": `CancellationPolicyManagement-btnWidth-_bO0f`,
	"bannerImageBg": `CancellationPolicyManagement-bannerImageBg-sct81`,
	"bannerDelete": `CancellationPolicyManagement-bannerDelete-OPtaz`,
	"modalRoot": `CancellationPolicyManagement-modalRoot-JEvWL`,
	"modalBorderBottom": `CancellationPolicyManagement-modalBorderBottom-L21Lr`,
	"logInModalBody": `CancellationPolicyManagement-logInModalBody-xGaTT`,
	"exportSection": `CancellationPolicyManagement-exportSection-Rpmh9`,
	"exportSectionGridSub": `CancellationPolicyManagement-exportSectionGridSub-oJ1u7`,
	"exportText": `CancellationPolicyManagement-exportText-pub_4`,
	"exportLinkImg": `CancellationPolicyManagement-exportLinkImg-MujIM`,
	"vtrMiddle": `CancellationPolicyManagement-vtrMiddle-sDAdm`,
	"exportImg": `CancellationPolicyManagement-exportImg-i81E7`,
	"profileViewlabel": `CancellationPolicyManagement-profileViewlabel-l_6Rz`,
	"profileViewMainContent": `CancellationPolicyManagement-profileViewMainContent-FVlyY`,
	"profileViewMain": `CancellationPolicyManagement-profileViewMain-I234Z`,
	"profileViewInner": `CancellationPolicyManagement-profileViewInner-zWNGL`,
	"profileImageSection": `CancellationPolicyManagement-profileImageSection-_buVN`,
	"lastviewInner": `CancellationPolicyManagement-lastviewInner-cs0Cx`,
	"whyHostHoriLine": `CancellationPolicyManagement-whyHostHoriLine-qUVWG`,
	"tableGrid": `CancellationPolicyManagement-tableGrid-HswnC`,
	"headingContent": `CancellationPolicyManagement-headingContent-rk3Fs`,
	"refundTextColor": `CancellationPolicyManagement-refundTextColor-mILpG`,
	"dividerLine": `CancellationPolicyManagement-dividerLine-ccbQp`,
	"smallContent": `CancellationPolicyManagement-smallContent-jDYVv`,
	"ChangeToUpperCase": `CancellationPolicyManagement-ChangeToUpperCase-eCf3r`,
	"noBorder": `CancellationPolicyManagement-noBorder-rU5yd`,
	"siteAdminHeading": `CancellationPolicyManagement-siteAdminHeading-P5WMZ`,
	"siteAdminSubHeading": `CancellationPolicyManagement-siteAdminSubHeading-dlML2`,
	"adminFormDivider": `CancellationPolicyManagement-adminFormDivider-OWaqb`,
	"errorMessage": `CancellationPolicyManagement-errorMessage-qoqFl`,
	"labelText": `CancellationPolicyManagement-labelText-agptO`,
	"space1": `CancellationPolicyManagement-space1-MHzkV`,
	"space2": `CancellationPolicyManagement-space2-FFBzq`,
	"space3": `CancellationPolicyManagement-space3-C0lUq`,
	"space4": `CancellationPolicyManagement-space4-BJuay`,
	"space5": `CancellationPolicyManagement-space5-uXpd0`,
	"space6": `CancellationPolicyManagement-space6-cqdmg`,
	"space7": `CancellationPolicyManagement-space7-kl7ui`,
	"spaceTop8": `CancellationPolicyManagement-spaceTop8-ZhGQu`,
	"spaceTop1": `CancellationPolicyManagement-spaceTop1-XdLoO`,
	"spaceTop2": `CancellationPolicyManagement-spaceTop2-kmjTA`,
	"spaceTop3": `CancellationPolicyManagement-spaceTop3-doHmD`,
	"spaceTop4": `CancellationPolicyManagement-spaceTop4-f4cKX`,
	"spaceTop5": `CancellationPolicyManagement-spaceTop5-fMFUn`,
	"spaceTop6": `CancellationPolicyManagement-spaceTop6-IkdYi`,
	"spaceTop7": `CancellationPolicyManagement-spaceTop7-mSq5J`,
	"padding1": `CancellationPolicyManagement-padding1-FQDFC`,
	"padding2": `CancellationPolicyManagement-padding2-aVaK2`,
	"padding3": `CancellationPolicyManagement-padding3-OqvXV`,
	"padding4": `CancellationPolicyManagement-padding4-kFcAh`,
	"padding5": `CancellationPolicyManagement-padding5-wGko2`,
	"padding6": `CancellationPolicyManagement-padding6-KTFAs`,
	"padding7": `CancellationPolicyManagement-padding7-eMibu`,
	"paddingTop1": `CancellationPolicyManagement-paddingTop1-dU8rN`,
	"paddingTop2": `CancellationPolicyManagement-paddingTop2-HauXV`,
	"paddingTop3": `CancellationPolicyManagement-paddingTop3-FcFnV`,
	"paddingTop4": `CancellationPolicyManagement-paddingTop4-Rq_EX`,
	"paddingTop5": `CancellationPolicyManagement-paddingTop5-cZ1w9`,
	"paddingTop6": `CancellationPolicyManagement-paddingTop6-eMWsk`,
	"paddingTop7": `CancellationPolicyManagement-paddingTop7-kzEOn`,
	"noPadding": `CancellationPolicyManagement-noPadding-flvo9`,
	"textBold": `CancellationPolicyManagement-textBold-uLMo7`,
	"textBolder": `CancellationPolicyManagement-textBolder-NkpVv`,
	"textNormal": `CancellationPolicyManagement-textNormal-VyKyT`,
	"spaceBottom20": `CancellationPolicyManagement-spaceBottom20-Bagj1`,
	"spaceBottom10": `CancellationPolicyManagement-spaceBottom10-PSq5E`,
	"marginNone": `CancellationPolicyManagement-marginNone-tqtXZ`,
	"spaceBottom15": `CancellationPolicyManagement-spaceBottom15-z8j8b`,
	"marginTopNone": `CancellationPolicyManagement-marginTopNone-W6GoS`,
	"spaceTop11": `CancellationPolicyManagement-spaceTop11-SMGgg`,
	"spaceTop21": `CancellationPolicyManagement-spaceTop21-mqgMb`,
	"spaceTop20": `CancellationPolicyManagement-spaceTop20-iqXE4`,
	"spaceTop10": `CancellationPolicyManagement-spaceTop10-N4m3V`,
	"textDarkBlue": `CancellationPolicyManagement-textDarkBlue-qijaL`,
	"textLightBlue": `CancellationPolicyManagement-textLightBlue-h8lif`,
	"textLightSandleGreen": `CancellationPolicyManagement-textLightSandleGreen-h04Gk`,
	"textLightBrown": `CancellationPolicyManagement-textLightBrown-v9Jwf`,
	"textMediumMaroon": `CancellationPolicyManagement-textMediumMaroon-BWH1Q`,
	"textBrown": `CancellationPolicyManagement-textBrown-udFxa`,
	"textMaroon": `CancellationPolicyManagement-textMaroon-NpnmH`,
	"textDarkBrown": `CancellationPolicyManagement-textDarkBrown-SGnxw`,
	"textMediumBrown": `CancellationPolicyManagement-textMediumBrown-ObStR`,
	"textSkyBlue": `CancellationPolicyManagement-textSkyBlue-UKAS6`,
	"textGray": `CancellationPolicyManagement-textGray-v9KxN`
};
module.exports = ___CSS_LOADER_EXPORT___;
